import { createApiCall } from 'lib/base';

const EDIT_SUBSCRIPTION = 'EDIT_SUBSCRIPTION';

const editSubscriptionApi = createApiCall<{ id: string; payload: any }>(
  EDIT_SUBSCRIPTION,
  ({ id, payload }) => ({
    endpoint: `api/admin/subscriptions/${id}`,
    method: 'PATCH',
    body: payload,
  })
);

export default editSubscriptionApi;
